import * as React from 'react'
import { Box, Fab, CircularProgress, Tooltip } from '@mui/material'
import { Check, Save, Edit, Visibility, DeleteOutline } from '@mui/icons-material'
import { green, red } from '@mui/material/colors'
import { updatePublicEvent } from '../../../services'

const PublicEventActions = ({ params, rowId, setRowId, onEdit, onView, onRequestDelete }) => {
  const [loading, setLoading] = React.useState(false)
  const [success, setSuccess] = React.useState(false)

  const handleSubmit = () => {
    setLoading(true)
    const { id, descripcion, endDate, isActive } = params.row
    const data = { descripcion, endDate, isActive: Boolean(isActive) }

    setTimeout(async () => {
      const result = await updatePublicEvent(data, id)
      if (result?.action === 'updated') {
        setSuccess(true)
        setRowId(null)
      }
      setLoading(false)
    }, 1000)
  }

  React.useEffect(() => {
    if (rowId === params.id && success) setSuccess(false)
  }, [rowId, params.id, success])

  return (
    <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center', m: 1 }}>
      <Tooltip title="Visualizar">
        <Fab
          color="default"
          sx={{ width: 40, height: 40 }}
          onClick={() => onView(params.row)}>
          <Visibility />
        </Fab>
      </Tooltip>

      <Tooltip title="Editar">
        <Fab
          color="info"
          sx={{ width: 40, height: 40 }}
          onClick={() => onEdit(params.row)}>
          <Edit />
        </Fab>
      </Tooltip>

      <Box sx={{ position: 'relative' }}>
        {success ? (
          <Fab
            color="primary"
            sx={{
              width: 40,
              height: 40,
              bgcolor: green[500],
              '&:hover': { bgcolor: green[700] },
            }}>
            <Check />
          </Fab>
        ) : (
          <Tooltip title="Guardar">
            <span>
              <Fab
                color="primary"
                sx={{ width: 40, height: 40 }}
                disabled={params.id !== rowId || loading}
                onClick={handleSubmit}>
                <Save />
              </Fab>
            </span>
          </Tooltip>
        )}
        {loading && (
          <CircularProgress
            size={52}
            sx={{ color: green[500], position: 'absolute', top: -6, left: -6, zIndex: 1 }}
          />
        )}
      </Box>

      <Tooltip title="Eliminar">
        <span>
          <Fab
            sx={{
              width: 40,
              height: 40,
              bgcolor: red[500],
              color: 'common.white',
              '&:hover': { bgcolor: red[700] },
            }}
            onClick={() => onRequestDelete(params.row)}>
            <DeleteOutline />
          </Fab>
        </span>
      </Tooltip>
    </Box>
  )
}

export default PublicEventActions
